module.exports = __webpack_public_path__ + "static/media/backward.30fe92f4.svg";